import * as React from 'react';

import { IBuilder, ISeller } from '../../types/newbuildingsCompare';
import { PhoneButton } from '../../components/NewbuildingCallToAction/PhoneButton';
import { useDynamicPhoneCall } from './useDynamicPhoneCall';

export interface ICallButtonProps {
  newbuildingId: number;
  url: string;
  target: IBuilder | ISeller;
  isBuilder: boolean;
  onlyIcon?: boolean;
  buttonText?: string;
  showButtonIcon?: boolean;
  fullWidth?: boolean;
  onShowPhone?: () => void;
}

/** Одиночный контакт: тап по кнопке сразу уходит в `tel:`. */
export const CallButton: React.FC<ICallButtonProps> = ({
  newbuildingId,
  url,
  target,
  isBuilder,
  onlyIcon,
  buttonText,
  showButtonIcon,
  fullWidth,
  onShowPhone,
}) => {
  const dial = useDynamicPhoneCall({
    newbuildingId,
    url,
    target,
    sellerType: isBuilder ? 'builders' : 'agents',
    onShowPhone,
  });

  return (
    <PhoneButton fullWidth={fullWidth} onlyIcon={onlyIcon} onClick={dial} showIcon={showButtonIcon} text={buttonText} />
  );
};
